import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CustomerPortalConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CustomerPortalService } from './api/customerPortal.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CustomerPortalApiModule {
    public static forRoot(configurationFactory: () => CustomerPortalConfiguration): ModuleWithProviders<CustomerPortalApiModule> {
        return {
            ngModule: CustomerPortalApiModule,
            providers: [ { provide: CustomerPortalConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CustomerPortalApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CustomerPortalApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
